<template>
  <div>
    <h4 class="my-2">Distribuie pe rețelele de socializare</h4>
    <share-network
      class="mr-4"
      network="facebook"
      :url="href"
      :title="article.title"
      :description="article.short_description"
      :quote="article.title"
    >
      <v-btn icon>
        <v-icon>fab fa-facebook-square</v-icon>
      </v-btn>
    </share-network>
    <share-network
      class="mr-4"
      network="twitter"
      :url="href"
      :title="article.title"
    >
      <v-btn icon>
        <v-icon dark>fab fa-twitter</v-icon>
      </v-btn>
    </share-network>
    <share-network
      class="mr-4"
      network="whatsapp"
      :url="href"
      :title="article.title"
    >
      <v-btn icon> <v-icon dark>fab fa-whatsapp-square</v-icon> </v-btn>
    </share-network>
    <share-network
      class="mr-4"
      network="email"
      :url="href"
      :title="article.title"
      :description="article.short_description"
    >
      <v-btn icon>
        <v-icon dark>fas fa-envelope</v-icon>
      </v-btn>
    </share-network>
  </div>
</template>

<script>
export default {
  name: 'SocialShare',
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  computed: {
    href() {
      return 'https://' + this.$store.state.app.tenant + this.$route.fullPath
    },
  },
}
</script>
